var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountDeclaration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.13,
    viewBox: "0 0 16 13.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_313",
    "data-name": "Union 313",
    d: "M1.833,13.13A1.822,1.822,0,0,1,0,11.324V4.431a1.821,1.821,0,0,1,1.833-1.8H3.28v.984H1.833A.828.828,0,0,0,1,4.431v6.893a.828.828,0,0,0,.834.82H14.167a.828.828,0,0,0,.834-.82V4.431a.828.828,0,0,0-.834-.82h-2.78V2.626h2.78A1.821,1.821,0,0,1,16,4.431v6.893a1.822,1.822,0,0,1-1.833,1.805ZM2.5,10.175V9.191h11v.985ZM2.15,8.384a.489.489,0,0,1-.13-.474L2.61,5.705a.485.485,0,0,1,.13-.223L8.16.144a.5.5,0,0,1,.706,0l1.65,1.625a.488.488,0,0,1,0,.7L5.1,7.8a.493.493,0,0,1-.226.128L2.63,8.513a.566.566,0,0,1-.127.015A.5.5,0,0,1,2.15,8.384Zm1.391-2.3L3.2,7.345l1.279-.332,4.972-4.9-.942-.929Zm6.291.809V5.908H13.5v.985Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDeclaration);
export default __webpack_public_path__ + "static/media/accountDeclaration.7f9af62dc2ceb5d680c1d371cfd7b00f.svg";
export { ForwardRef as ReactComponent };